import React from "react";
import GlobalStyle from "../FixedStyled";
import ScrollToTop from "../Rootelements/Homepagesubfiles/Scrolltotop";
import { Navbar, Footer } from "../Rootelements/Homepagesubfiles";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Aboutcrew from '../Rootelements/Aboutussubfiles/Aboutcrew';

const theme = createTheme();

const cards = [1,2,3,4,5,6,7,8,9,10,11,12,13,14];


function Aboutus(){
    return(
        <div>
        <GlobalStyle />
        <ScrollToTop />
        <Navbar />
        <Aboutcrew />
        <Footer />
        </div>
    )
};

export default Aboutus;